
import { IDecimalRoundBehaviorPropertyEditable, instanceOfIDecimalRoundBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";
import { Component, Mixins } from "vue-property-decorator";
import { IDecimalRoundBehavior } from "../../../../../../documaker/domain/format/objects";

@Component
export default class DecimalRoundBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IDecimalRoundBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDecimalRoundBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isDecimalRoundBehaviorEnable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDecimalRoundBehaviorPropertyEditable(s) && s.decimalRoundBehavior().isEditable() , false);
  }

  get decimalRoundBehavior(): IDecimalRoundBehavior {
    return this.readPropertyOrDefault(s => s.decimalRoundBehavior().getValue(), null);
  }

  set decimalRoundBehavior(value: IDecimalRoundBehavior) {
    this.writePropertyWhenValid(s => s.decimalRoundBehavior().setValue(value));
  }
}
